import SongComponent from '../../../components/SongComponent'
import { Song } from '../../../__generated__/graphql'

const SongList: React.FC<{
  songs: Song[]
  isFlat: boolean
  inList: boolean
}> = ({ songs, isFlat, inList }) => {
  const songsElements = songs.map((song, index) => {
    return (
      <SongComponent
        priority={index >= 0 && index <= 3} //preload first 4 images visible on mobile
        key={song.id}
        song={song}
        isFlat={isFlat}
        inList={inList}
        displayEditButton={true}
        hasTextScroll={true}
      />
    )
  })

  return <>{songsElements}</>
}

export default SongList
